module.exports = {"330302006":"五马街道","330302023":"七都街道","330302024":"滨江街道","330302025":"南汇街道","330302026":"松台街道","330302027":"双屿街道","330302028":"仰义街道","330302029":"大南街道","330302030":"蒲鞋市街道","330302031":"南郊街道","330302032":"广化街道","330302033":"丰门街道","330302102":"藤桥镇","330302105":"山福镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330302.json
// module id = 1069
// module chunks = 0